var Member = require('member');
var User = require('user');
var UserList = require('userlist');
var util = require('../lib/util.es6');


var MemberList = UserList.extend({
    model: Member,
    initialize: function (models, modeCategory, connection) {
        this.modeCategory = modeCategory;
        this.connection = connection;
    },
    isMember: function () {
        return this.getModeCategory() === 'MEMBER';
    },
    getModeCategory: function () {
        return this.modeCategory;
    },
    getModeTitle: function () {
        return User.defaultTitles[this.getModeCategory()] || this.getModeCategory();
    },
    getClass: function () {
        return User.defaultClassNames[this.getModeCategory()] ||
            'mode_' + this.getModeCategory();
    },
    getMode: function () {
        return this.connection.getUserModes()[this.getModeCategory()];
    },
    getPrefixSymbol: function () {
        return User.prototype.getPrefixSymbol.call(this);
    },
    getModeSymbol: function () {
        return User.prototype.getModeSymbol.call(this);
    },
    comparator: function (memberA, memberB) {
        return util.naturalCompare(memberA.normalise(), memberB.normalise());
    }
});


module.exports = MemberList;



//////////////////
// WEBPACK FOOTER
// ./app/src/collection/memberlist.js
// module id = XZrG
// module chunks = 1